export default {
  allActivities: (state) => state.activities,
  activitiesLoading: (state) => (state.activitiesLoading),
  savedOpenPanels: (state) => (state.openPanels),
  activitiesByEntity: (state) => state.activitiesByEntity
}
